<template>
  <Modal v-model="endSortingModal" width="1100" :styles="{ top: '100px' }" class-name="endSortingModalStyle"
    :mask-closable="false" :title="endSortingTitle" :closable="false" @on-visible-change="endSortingModalChange">
    <Alert type="warning" show-icon>
      <Icon slot="icon" type="md-information-circle" color="#ffcc00" size="39" style="vertical-align:middle;"></Icon>
      <div slot="desc" class="font-size-16">
        {{ $t('key1004941').replace('{pickingGoodsNo}', pickingGoodsNo) }}：
      </div>
    </Alert>
    <div class="endSorting_box">
      <div class="endSorting_center">
        <div class="endSorting_left_box">
          <h2 style="color:#ff0000;" class="mt5 mb5">{{ $t('key1004942') }}</h2>
          <Table
            ref="nopickTable"
            border
            height="300"
            :columns="nopickDataColumn"
            :data="nopickData">
          </Table>
          <div class="mt10 font-size-14">
            <p class="mb5">{{ $t('key1004824') }}</p>
            <p>{{ $t('key1004943') }}</p>
            <p>{{ $t('key1004944') }}</p>
            <p>{{ $t('key1004945') }}</p>
          </div>
        </div>
        <div class="endSorting_right_box">
          <Table
            ref="nopickGoodsTable"
            border
            height="300"
            :columns="nopickGoodsColumn"
            :data="nopickGoodsData">
          </Table>
          <div class="mt10 font-size-14">
            <p>{{ $t('key1004946') }}</p>
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="flex align-items-center justify-content-between">
        <div class="cancel_box">
          <div class="mt10" v-if="getPermission('ymsPickingOrder_resetSorting')">
            {{ $t('key1004947') }} {{ $t('key1004948') }}
            <span class="blueColor cursor" @click="cancelPick">{{ $t('key1004949') }}</span>
            {{ $t('key1004950') }}
          </div>
        </div>
        <div class="flex align-items-center">
          <Button type="error" @click="forcedEndBtn" v-if="getPermission('ymsPickingOrder_endSorting')">{{ $t('key1004002') }}</Button>
          <Button type="primary" @click="endSortingModal = false">{{ $t('key1004951') }}</Button>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';

export default {
  name: "endSortingModal",
  mixins: [Mixin],
  data() {
    return {
      endSortingModal: false,
      endSortingTitle: '',
      pickingGoodsNo: '',
      nopickDataColumn: [
        {
          title: 'NO',
          width: 60,
          align: 'center',
          type: 'index',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004933'),
          key: 'boxNo',
          align: 'center',
          render: (h, params) => {
            if (params.row.noBoxNo) {
              return h('div', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004934'));
            } else {
              return h('div', params.row.boxNo);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001248'),
          key: 'packageCode',
          align: 'center',
          render: (h, params) => {
            return h('span', {
              style: {
                color: '#1e5494'
              }
            }, params.row.packageCode);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004935'),
          key: 'skus',
          align: 'center',
          render: (h, params) => {
            if (params.row.noBoxNo) {
              let list = params.row.sortingPackageGoodsResult;
              let pos = [];
              list.forEach((n, i) => {
                let item = h('div', [h('div', n.sku + '（' + n.haveSkuNum + ' / ' + (n.quantity - n.haveSkuNum) + '）')]);
                pos.push(item);
              });
              return h('div', pos);
            } else {
              let list = params.row.boxData ? params.row.boxData.sortingPackageGoodsResult : params.row.sortingPackageGoodsResult;
              let pos = [];
              if (list) {
                list.forEach((n, i) => {
                  if (n.haveSkuNum < n.quantity) {
                    let item = h('div', [h('div', n.sku + '（' + n.haveSkuNum + ' / ' + (n.quantity - n.haveSkuNum) + '）')]);
                    pos.push(item);
                  }
                });
              }
              return h('div', pos);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004936'),
          key: 'abnormalCause',
          align: 'center',
          render: (h, params) => {
            if (params.row.noBoxNo) {
              return h('div', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004937'));
            } else {
              return h('div', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004938'));
            }
          }
        }
      ],
      nopickData: [], // 未完成所有货品分拣的包裹数据列表
      nopickGoodsColumn: [
        {
          title: 'NO',
          width: 60,
          align: 'center',
          type: 'index',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004851'),
          key: 'sku',
          align: 'center',
          render: (h, params) => {
            return h('span', {
              style: {
                color: '#008000'
              }
            }, params.row.sku);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004939'),
          key: 'haveNum',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004940'),
          key: 'picked',
          align: 'center',
          render: (h, params) => {
            return h('div', params.row.quantity - params.row.haveNum);
          }
        }
      ],
      nopickGoodsData: [], // 为完成分拣货品列表
      ymsPickingOrderId: null,
      orderType: null,
      pickGoodsData: []
    };
  },
  methods: {
    // 初始化数据
    initEndSortingData(title, pickingGoodsNo, ymsPickingOrderId, nopickGoodsData, nopickData, type) {
      this.endSortingTitle = title;
      this.pickingGoodsNo = pickingGoodsNo;
      this.nopickGoodsData = nopickGoodsData;
      this.ymsPickingOrderId = ymsPickingOrderId;
      this.orderType = type;
      if (type === 'TEMU_S') {
        this.handlePackageCodeData(nopickData);
      } else {
        this.nopickData = nopickData;
      }
      this.endSortingModal = true;
    },
    // 因为样品单是按照运单号的维度分拣货篮，可能会存在多个出库单
    handlePackageCodeData(nopickData) {
      let v = this;
      let newData = [];
      if (nopickData.length > 0) {
        let newList = [];
        nopickData.map((item) => {
          let sortingPackageGoodsResult = [];
          if (item.boxData) {
            sortingPackageGoodsResult = item.boxData.sortingPackageGoodsResult;
            sortingPackageGoodsResult.map((ele) => {
              ele.boxNo = item.boxNo;
            });
          } else {
            sortingPackageGoodsResult = item.sortingPackageGoodsResult;
          }
          let unselectedList = sortingPackageGoodsResult.filter((item) => {
            return item.quantity !== item.haveSkuNum;
          });
          newList.push(...unselectedList);
        });
        if (newList.length > 0) {
          let list = v.handerGrouping(newList, function (item) {
            return [item.packageCode];
          }, 'packageCode');
          if (list.length > 0) {
            list.map((item) => {
              newList.map((ele) => {
                if (item.packageCode === ele.packageCode) {
                  newData.push({
                    noBoxNo: ele.noBoxNo,
                    boxNo: ele.boxNo,
                    packageCode: item.packageCode,
                    packageId: ele.ymsPackageId,
                    sortingPackageGoodsResult: item.data,
                    ymsPickingOrderRelatedId: ele.ymsPickingOrderRelatedId,
                  });
                }
              });
            });
          }
        }
        v.nopickData = this.uniqueFunc(newData, 'packageCode');
      }
    },
    // 强制结束
    forcedEndBtn() {
      let v = this;
      let pos = [];
      if (v.orderType === 'TEMU_S') {
        if (v.pickGoodsData.length > 0) {
          let list = v.handerGrouping(v.pickGoodsData, function (item) {
            return [item.packageCode];
          }, 'packageCode');
          if (list.length > 0) {
            list.map((item) => {
              let scanTalg = item.data.some((ele) => {
                return ele.haveNum > 0;
              });
              if (!scanTalg) {
                pos.push(item.data[0].ymsPickingOrderRelatedId);
              }
            });
          }
        }
      } else {
        v.nopickData.forEach((n, i) => {
          pos.push(n.ymsPickingOrderRelatedId);
        });
      }
      let obj = {
        ymsPickingOrderRelatedIds: pos || [],
        ymsPickingOrderId: v.ymsPickingOrderId,
      };
      v.$emit('endsortingBtn', obj);
    },
    // 撤销本次分拣
    cancelPick() {
      let v = this;
      v.axios.put(api.put_ymsPickingOrder_resetSorting + `?ymsPickingOrderId=${v.ymsPickingOrderId}`).then(response => {
        if (response.data.code === 0) {
          v.endSortingModal = true;
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
          setTimeout(() => {
            v.$router.push('/wms/sorting');
          }, 800);
        }
      });
    },
    // 监听弹窗
    endSortingModalChange(value) {
      if (!value) {
        this.pickGoodsData = [];
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .endSortingModalStyle {
  .endSorting_box {
    border: 1px solid #ccc;
    background: #d6e9f2;
    margin-top: 20px;

    .endSorting_center {
      padding: 0 15px 15px 15px;
      display: flex;
      justify-content: space-between;

      .endSorting_left_box {
        width: 670px;
        display: flex;
        flex-direction: column;
      }

      .endSorting_right_box {
        margin-top: 31px;
        width: 350px;
        display: flex;
        flex-direction: column;
      }
    }
  }

  .ivu-modal-footer /deep/ {
    .cancel_box {
      width: 500px;
      border: 1px solid #ccc;
      background: #ffffcc;
      text-align: left;
      padding: 5px 10px;
    }
  }
}
</style>